module.exports = __webpack_public_path__ + "inistate-logo-full.png?b6a1bcc566d8ae0fdac33b81d17a8f94";